<script setup lang="ts">
defineOptions({ name: "DisplayVersion" });
const { $config } = useNuxtApp();

const props = defineProps({
  theme: {
    type: String as PropType<"default" | "blue">,
    default: "default",
  },
});

const containerClasses = computed(() => {
  const baseClasses = "text-xs";

  if (props.theme === "blue") {
    return `${baseClasses} font-normal text-nblue-1 color-nblue-2`; // this is finicky
  }

  return baseClasses;
});

const versionNumber = computed(() => $config.public.VERSION || "local");
const buildTimestamp = computed(() => $config.public.BUILD_TIMESTAMP);
</script>

<template>
  <dl :class="containerClasses">
    <dt>{{ $t("desc.versionNumber") }}:</dt>
    <dd>{{ versionNumber }}</dd>
    <dt>{{ $t("desc.versionBuildTime") }}:</dt>
    <dd>{{ buildTimestamp }}</dd>
  </dl>
</template>

<style scoped lang="postcss">
dl {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 0.25rem;
}

dl:not(.color-nblue-2) {
  color: hsl(from var(--color-ngray-1) h s l / 0.5);
}
</style>
